module.exports = __webpack_public_path__ + "img/projeto_vivo_acordos_de_cobranca.844f9fea.jpg";